// 事件常量定义
export const SENSOR_MONITORING_STATE_CHANGED = "sensor_monitoring_state_changed";